import React from 'react'
import PropTypes from 'prop-types'
// import colors from '../../utils/colors'
import styles from './checkbox.module.css'

const Checkbox = ({id, label, className, defaultChecked, itemsCentered, rounded, ...rest}) => {
  // Note
  // Componentnya saya ubah jadi uncontrolled, kalau mau jadi controlled
  // setCheckednya ga bisa disini, harus di parent component
  // yang ngatur state checked

  // const [checked, setChecked] = React.useState(defaultChecked ? true : false)
  // const handleChange = (e) => {
  //   console.log(e.target)
  //   e.preventDefault()
  //   e.stopPropagation()

  //   setChecked(e.target.checked)
  // }

  const roundedStyle = {
    borderRadius: rounded ? '5px' : '0',
  }

  return (
    <label className={`flex ${className} ${styles.checkbox} ${itemsCentered ? 'items-center' : ''}`}>
      <div className="bg-white">
        <input
          type="checkbox"
          id={id}
          className="hidden"
          {...rest}
        />
        <div style={roundedStyle} className={`${label ? 'mr-2' : ''} border flex justify-center items-center ${styles.outer}`}>
          <div style={roundedStyle} className={styles.inner}></div>
        </div>
      </div>
      <div className="cursor-pointer text-sm text-gray-444" htmlFor={id}>{label}</div>
    </label>
  )
}

Checkbox.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string,
  defaultChecked: PropTypes.bool,
  itemsCentered: PropTypes.bool,
  rounded: PropTypes.bool,
}

Checkbox.defaultProps = {
  id: '',
  label: '',
  onChange: () => {},
  className: '',
  defaultChecked: false,
  itemsCentered: false,
  rounded: false,
}

export { Checkbox }
